// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    text-align: center;
    width: 100%;
    height: 100vh;
}
.Custom-Container {
    text-align: center;
    width: 100%;
    height: 100vh;
    position: relative;
}

.App-logo {
    height: 40vmin;
    pointer-events: none;
}
.App::-webkit-scrollbar {
    display: none;
}

@media (min-width: 600px) {
    .Custom-Container {
        width: 60%;
        margin-left: auto;
        margin-right: auto;
    }
    [data-rsbs-overlay] {
        width: 60%;
        margin-left: auto !important;
        margin-right: auto !important;
    }
}


.App-link {
    color: #61dafb;
}
[data-rsbs-backdrop] {
    background-color: rgba(255, 255, 255, 0.6) !important;
    background-color: var(--rsbs-backdrop-bg, rgba(97, 95, 95, 0.6)) !important;
    will-change: opacity;
    cursor: pointer;
    opacity: 1;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
/* 
#root {
    text-align: center;
    display: flex;
    justify-content: center;
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: linear-gradient(#fff, #999);
} */

.kosugi-regular {
    font-family: "Kosugi", sans-serif;
    font-weight: 400;
    font-style: normal;
}

.kiwi-maru-light {
    font-family: "Kiwi Maru", serif !important;
    font-weight: 300 !important;
    font-style: normal !important;
}

.kiwi-maru-regular {
    font-family: "Kiwi Maru", serif !important;
    font-weight: 400 !important;
    font-style: normal !important;
}

.kiwi-maru-medium {
    font-family: "Kiwi Maru", serif !important;
    font-weight: 700 !important;
    font-style: normal !important;
}

.css-jh47zj-MuiButtonBase-root-MuiButton-root {
    background-color: rgb(228, 158, 74) !important;
}
.css-9y1egq-MuiButtonBase-root-MuiButton-root {
    color: rgb(228, 158, 74) !important;
    border: 1px solid rgba(228, 158, 74, 0.5) !important;
}
ruby{
    font-weight: 500;
}
/* ruby > rt {
    margin-bottom: -20px !important;
}
ruby ,rt {
    margin-bottom: -20px !important;
    color: red;
} */

.isSafari {
    line-height: 1.7rem;
}

  /* .isSafari  rt {
    translate: 0 0.5rem !important;
    margin-top: -10px !important;
  }
  ruby > rt {
    display: block !important;
  }
  ruby{
    display: ruby !important;
  } */
 /* ruby > rt{
  
   
   margin-bottom: -10px;
 } */
 
 
 ruby > rt {
    /* display: block; */
    translate: 0 0.5rem;
    /* display: fixed;
    top: 0; */
    /* display:inline; */
 }
 
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;QACV,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,4BAA4B;QAC5B,6BAA6B;IACjC;AACJ;;;AAGA;IACI,cAAc;AAClB;AACA;IACI,qDAAqD;IACrD,2EAA2E;IAC3E,oBAAoB;IACpB,eAAe;IACf,UAAU;AACd;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;;;;;;;;;GASG;;AAEH;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,8CAA8C;AAClD;AACA;IACI,mCAAmC;IACnC,oDAAoD;AACxD;AACA;IACI,gBAAgB;AACpB;AACA;;;;;;GAMG;;AAEH;IACI,mBAAmB;AACvB;;EAEE;;;;;;;;;KASG;CACJ;;;;IAIG;;;CAGH;IACG,oBAAoB;IACpB,mBAAmB;IACnB;aACS;IACT,oBAAoB;CACvB","sourcesContent":[".App {\r\n    text-align: center;\r\n    width: 100%;\r\n    height: 100vh;\r\n}\r\n.Custom-Container {\r\n    text-align: center;\r\n    width: 100%;\r\n    height: 100vh;\r\n    position: relative;\r\n}\r\n\r\n.App-logo {\r\n    height: 40vmin;\r\n    pointer-events: none;\r\n}\r\n.App::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n\r\n@media (min-width: 600px) {\r\n    .Custom-Container {\r\n        width: 60%;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n    [data-rsbs-overlay] {\r\n        width: 60%;\r\n        margin-left: auto !important;\r\n        margin-right: auto !important;\r\n    }\r\n}\r\n\r\n\r\n.App-link {\r\n    color: #61dafb;\r\n}\r\n[data-rsbs-backdrop] {\r\n    background-color: rgba(255, 255, 255, 0.6) !important;\r\n    background-color: var(--rsbs-backdrop-bg, rgba(97, 95, 95, 0.6)) !important;\r\n    will-change: opacity;\r\n    cursor: pointer;\r\n    opacity: 1;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n/* \r\n#root {\r\n    text-align: center;\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 100vw;\r\n    min-height: 100vh;\r\n    overflow: hidden;\r\n    background: linear-gradient(#fff, #999);\r\n} */\r\n\r\n.kosugi-regular {\r\n    font-family: \"Kosugi\", sans-serif;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n}\r\n\r\n.kiwi-maru-light {\r\n    font-family: \"Kiwi Maru\", serif !important;\r\n    font-weight: 300 !important;\r\n    font-style: normal !important;\r\n}\r\n\r\n.kiwi-maru-regular {\r\n    font-family: \"Kiwi Maru\", serif !important;\r\n    font-weight: 400 !important;\r\n    font-style: normal !important;\r\n}\r\n\r\n.kiwi-maru-medium {\r\n    font-family: \"Kiwi Maru\", serif !important;\r\n    font-weight: 700 !important;\r\n    font-style: normal !important;\r\n}\r\n\r\n.css-jh47zj-MuiButtonBase-root-MuiButton-root {\r\n    background-color: rgb(228, 158, 74) !important;\r\n}\r\n.css-9y1egq-MuiButtonBase-root-MuiButton-root {\r\n    color: rgb(228, 158, 74) !important;\r\n    border: 1px solid rgba(228, 158, 74, 0.5) !important;\r\n}\r\nruby{\r\n    font-weight: 500;\r\n}\r\n/* ruby > rt {\r\n    margin-bottom: -20px !important;\r\n}\r\nruby ,rt {\r\n    margin-bottom: -20px !important;\r\n    color: red;\r\n} */\r\n\r\n.isSafari {\r\n    line-height: 1.7rem;\r\n}\r\n\r\n  /* .isSafari  rt {\r\n    translate: 0 0.5rem !important;\r\n    margin-top: -10px !important;\r\n  }\r\n  ruby > rt {\r\n    display: block !important;\r\n  }\r\n  ruby{\r\n    display: ruby !important;\r\n  } */\r\n /* ruby > rt{\r\n  \r\n   \r\n   margin-bottom: -10px;\r\n } */\r\n \r\n \r\n ruby > rt {\r\n    /* display: block; */\r\n    translate: 0 0.5rem;\r\n    /* display: fixed;\r\n    top: 0; */\r\n    /* display:inline; */\r\n }\r\n \r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
